// @flow

import { type OutgoingPayment } from '../outgoing-payment/types';
import { type UserInputValues } from '@tectonics/prs/user-input-values';

export async function eftColombiaOutgoingPaymentMapper(
  userInputValues: UserInputValues,
): Promise<$Shape<OutgoingPayment>> {
  const eftCode = userInputValues['selectedEftBank'];

  return {
    payment_type: 'eft',
    payment_type_code: 'eft',
    eft_code: eftCode,
    instalments: '1',
  };
}
